import { render, staticRenderFns } from "./archiveType.vue?vue&type=template&id=92b5f4e4&"
import script from "./archiveType.vue?vue&type=script&lang=js&"
export * from "./archiveType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports